'use strict';

/* eslint no-undef: "off" */
/**
 * get stores list api
 */
define('getStoresListApi',['baseApiGet'], function (baseApiGet) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiGet('/rest/V1/xpark-app/offline-stores', params);
  };
});
